let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jkUKZ")).then(() => parcelRequire('4V7KZ'));